export const LOGIN = '/auth/login';
// export const LOGOUT = '/auth/logout';
export const FORGOT = '/auth/forgotPassword';
export const RESEND_OTP = '/auth/resendOTP';
export const RESET_PASSWORD = '/auth/resetPassword';
export const CHANGE_PASSWORD = '/auth/changePassword';

export const TRAILS_LIST = '/trails/list';
export const TRAILS_ADD = '/trails/add';
export const TRAILS_EDIT = '/trails/edit';
export const TRAILS_STATUS = '/trails/changeStatus';
export const UPLOAD_GPX = '/trails/upload-gpx';

export const SUGGESTED_TRAILS = '/suggestedTrails/list';
export const SUGGESTED_TRAILS_STATUS = '/suggestedTrails/changeStatus';
